export const CLASSIFICATION_OPTIONS = [
  { value: 'ALERT_SERVICE_BULLETIN', label: 'Alert - Service Bulletin' },
  { value: 'SERVICE_BULLETIN', label: 'Service Bulletin' },
  { value: 'AIRWORTHINESS_DIRECTIVE', label: 'Airworthiness Directive' }
];

export const PRIORITY_OPTIONS = [
  { value: 'MANDATORY_SERVICE_BULLETIN', label: 'Mandatory Bulletin' },
  { value: 'OPTIONAL_SERVICE_BULLETIN', label: 'Optional Bulletin' },
  { value: 'RECOMMENDED_SERVICE_BULLETIN', label: 'Recommended' }
];

export const priorityLabel = (v) => PRIORITY_OPTIONS.find(o => o.value === v)?.label ?? v ?? '—';

export const SOURCE_OPTIONS = [
  { value: 'MANUFACTURER', label: 'Manufacturer' },
  { value: 'DGCA_MANDATORY_MODIFICATIONS', label: 'DGCA Mandatory Modifications' },
  { value: 'MISC_MODELS_MODIFICATIONS', label: 'Misc Models Modifications' },
  { value: 'OTHER', label: 'Other (custom)' }
];

export const REGULATORY_AUTHORITY_OPTIONS = [
  { value: 'DGCA', label: 'DGCA' },
  { value: 'FAA', label: 'FAA' },
  { value: 'EASA', label: 'EASA' },
  { value: 'OTHER', label: 'Other (custom)' }
];
